var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testReport_pages3"},[_c('div',{staticClass:"testReport_pages3_d"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"title"},[_vm._v("睡眠")]),_c('div',{staticClass:"report_type"},[_vm._v("功能分析报告")])]),_c('div',{staticClass:"testReport_pages3_r"},[_c('div',[_vm._v("ANALYSIS")]),_c('div',[_vm._v(" HEALTH REPORT")])])])
}]

export { render, staticRenderFns }